import application from 'application/application';

import angular from 'angular';

application

	.directive('ngCheckAll', ['$timeout', '$parse', ($timeout, $parse) => ({
		restrict: 'A',
		scope: {
			ngCheckAll: '='
		},
		link(scope, element, attrs) {

			var $element = $(element);

			$element.on('change', () => {

				let

					childrens = attrs.ngCheckAllChildren ? attrs.ngCheckAllChildren.split('.') : attrs.ngCheckAllChildren,

					recursiveCheck = (item, control) => {

						item[attrs.ngCheckAllProperty] = $element.prop('checked');

						control++;

						childrens && item[childrens[control]] && item[childrens[control]].forEach(item => {

							recursiveCheck(item, control);

						});

					};

				$parse(attrs.ngCheckAll)(angular.element(element).scope()).forEach(item => {

					let control = -1;

					recursiveCheck(item, control);

				});

				$element.prop('indeterminate', false);

				$timeout(() => scope.$apply());

			});

		}
	})]);
